import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/app/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import ThemeProvider from '../../Theme/ThemeProvider';
import Flex from '../../Layout/Flex';
import SelectWithFiltering from './SelectWithFiltering';
import Select from './Select';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "select"
    }}>{`Select`}</h1>
    <Playground __position={0} __code={'<ThemeProvider>\n  <div style={{ padding: \'16px\' }}>\n    <Select isFullWidth>\n      <Flex value=\"foo\">foo</Flex>\n      <Flex value=\"bar\">bar</Flex>\n    </Select>\n    <br />\n  </div>\n</ThemeProvider>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      ThemeProvider,
      Flex,
      SelectWithFiltering,
      Select,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <ThemeProvider mdxType="ThemeProvider">
    <div style={{
          padding: '16px'
        }}>
      <Select isFullWidth mdxType="Select">
        <Flex value='foo' mdxType="Flex">foo</Flex>
        <Flex value='bar' mdxType="Flex">bar</Flex>
      </Select>
      <br />
    </div>
  </ThemeProvider>
    </Playground>
    <h1 {...{
      "id": "selectwithfiltering"
    }}>{`SelectWithFiltering`}</h1>
    <Playground __position={1} __code={'<ThemeProvider>\n  <div style={{ padding: \'16px\' }}>\n    <SelectWithFiltering>\n      <Flex value=\"foo\">foo</Flex>\n      <Flex value=\"bar\">bar</Flex>\n    </SelectWithFiltering>\n    <br />\n  </div>\n</ThemeProvider>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      ThemeProvider,
      Flex,
      SelectWithFiltering,
      Select,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <ThemeProvider mdxType="ThemeProvider">
    <div style={{
          padding: '16px'
        }}>
      <SelectWithFiltering mdxType="SelectWithFiltering">
        <Flex value='foo' mdxType="Flex">foo</Flex>
        <Flex value='bar' mdxType="Flex">bar</Flex>
      </SelectWithFiltering>
      <br />
    </div>
  </ThemeProvider>
    </Playground>
    {
      /*
      # API
      <Props of={SelectWithFiltering} />
      */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      